export const SEARCH_SELECT = 'search-select';
export const GEOCODE_POPUP = 'geocode-popup';
export const SEARCH_RESULT = 'search-result';
export const SET_DEFAULT_SEARCH = 'search-set';
export const STYLE_SEARCH = 'search-update-style';
export const RESTRICT_SEARCH = 'search-restict';
export const SEARCH_CHANGED = 'search-changed';
export const SEARCH_FLYTO = 'search-flyto';
